var h = require("./virtual-hyperscript/index.js")

module.exports = h



//////////////////
// WEBPACK FOOTER
// ./~/virtual-dom/h.js
// module id = 38
// module chunks = 0